/**
 * GnuCash-style register labels per account type — ported verbatim from
 * legacy's `DEBIT_LABELS`/`CREDIT_LABELS` (assets/app.js).
 *
 * Shared because legacy shares them: the transaction editor shows them above
 * each split's debit/credit inputs, and the reports show them beside each
 * leg's amount. Two copies would drift, and the whole point of the vocabulary
 * is that "Increase" means the same thing wherever an asset account appears.
 */
const DEBIT_LABELS: Record<string, string> = { ASSET: 'Increase', LIABILITY: 'Decrease', EQUITY: 'Decrease', INCOME: 'Charge', EXPENSE: 'Expense' };
const CREDIT_LABELS: Record<string, string> = { ASSET: 'Decrease', LIABILITY: 'Increase', EQUITY: 'Increase', INCOME: 'Income', EXPENSE: 'Rebate' };

export function debitLabel(type: string | undefined): string { return (type && DEBIT_LABELS[type]) || 'Debit'; }
export function creditLabel(type: string | undefined): string { return (type && CREDIT_LABELS[type]) || 'Credit'; }

/** The label for an amount, chosen by its sign — legacy picks debit for `>= 0`, including exact zero. */
export function amountLabel(amount: string | number, type: string | undefined): string {
  return Number(amount) >= 0 ? debitLabel(type) : creditLabel(type);
}
